import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import TimeBlock from './TimeBlock';
import { isMobile } from 'react-device-detect';
// import dateFormat from "dateformat";

class WeekBlock extends Component {
  state = {
    bWidth: isMobile ? 390 : 1920,
  };
  componentDidMount = () => {
    const today = new Date();
    const curHour = today.getHours(); // 시

    window.addEventListener('resize', this._onResize);
    this.setState({
      curHour,
    });
  };
  _onResize = () => {
    console.log(window.innerWidth);
    this.setState({
      bWidth: window.innerWidth,
    });
  };
  componentWillUnmount = () => {
    window.removeEventListener('resize', this._onResize);
  };
  render() {
    const { thisWeek, hour, renderItem, theDayOfWeek, part } =
      this.props.childProps;
    const { curHour, bWidth } = this.state;
    let time;
    //console.log(hour)
    if (hour <= 9) {
      time = '0' + hour.toString();
    } else {
      time = hour;
    }
    console.log(thisWeek);
    console.log(theDayOfWeek);
    console.log(bWidth);
    //console.log(thisWeek[1])
    // const curDate = new Date();
    // const toDay = dateFormat(curDate, "yyyy-mm-dd");
    //console.log(toDay)
    return (
      <Fragment>
        <div className="div_ul">
          <div className={hour === curHour ? 'div_li_time on' : 'div_li_time'}>
            <div>{time}시</div>
          </div>
          {bWidth <= 1024 ? (
            <>
              <div className={'div_li on'}>
                <TimeBlock
                  timeItems={renderItem(thisWeek[theDayOfWeek], hour)}
                  part={part}
                />
              </div>
              <div className={'div_li'}>
                <TimeBlock
                  timeItems={renderItem(
                    theDayOfWeek === 7
                      ? thisWeek[1]
                      : thisWeek[theDayOfWeek + 1],
                    hour
                  )}
                  part={part}
                />
              </div>
              <div className={'div_li'}>
                <TimeBlock
                  timeItems={renderItem(
                    theDayOfWeek === 7
                      ? thisWeek[2]
                      : thisWeek[theDayOfWeek + 2],
                    hour
                  )}
                  part={part}
                />
              </div>
            </>
          ) : (
            <>
              {/*월요일 00시*/}
              <div className={theDayOfWeek === 1 ? 'div_li on' : 'div_li'}>
                <TimeBlock
                  timeItems={renderItem(thisWeek[1], hour)}
                  part={part}
                />
              </div>
              {/*화요일 00시*/}
              <div className={theDayOfWeek === 2 ? 'div_li on' : 'div_li'}>
                <TimeBlock
                  timeItems={renderItem(thisWeek[2], hour)}
                  part={part}
                />
              </div>
              {/*수요일 00시*/}
              <div className={theDayOfWeek === 3 ? 'div_li on' : 'div_li'}>
                <TimeBlock
                  timeItems={renderItem(thisWeek[3], hour)}
                  part={part}
                />
              </div>
              {/*목요일 00시*/}
              <div className={theDayOfWeek === 4 ? 'div_li on' : 'div_li'}>
                <TimeBlock
                  timeItems={renderItem(thisWeek[4], hour)}
                  part={part}
                />
              </div>
              {/*금요일 00시*/}
              <div className={theDayOfWeek === 5 ? 'div_li on' : 'div_li'}>
                <TimeBlock
                  timeItems={renderItem(thisWeek[5], hour)}
                  part={part}
                />
              </div>
              {/*토요일 00시*/}
              <div className={theDayOfWeek === 6 ? 'div_li on' : 'div_li'}>
                <TimeBlock
                  timeItems={renderItem(thisWeek[6], hour)}
                  part={part}
                />
              </div>
              {/*일요일 00시*/}
              <div className={theDayOfWeek === 0 ? 'div_li on' : 'div_li'}>
                <TimeBlock
                  timeItems={renderItem(thisWeek[7], hour)}
                  part={part}
                />
              </div>
            </>
          )}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(WeekBlock));
